import React from 'react';

export const Error = () => (<div><h1>Oops Something went wrong!</h1></div>);

export default Error;
